/**
 * MEXC Exchange Metadata
 */

import { MEXC_WS_CHANNELS, MEXC_WS_TOPOLOGY } from './ws';

import type { ExchangeId } from '../../lib/types';

export const MEXC_METADATA = {
  id: 'mexc' as ExchangeId,
  restDocs: [
    'https://mexcdevelop.github.io/apidocs/spot_v3_en/',
    'https://mexcdevelop.github.io/apidocs/spot_v3_en/#order-book',
    'https://mexcdevelop.github.io/apidocs/spot_v3_en/#kline-candlestick-data',
    'https://mexcdevelop.github.io/apidocs/spot_v3_en/#recent-trades-list',
  ],
  wsDocs: [
    'https://mexcdevelop.github.io/apidocs/spot_v3_en/#websocket-market-streams',
    'https://mexcdevelop.github.io/apidocs/spot_v3_en/#websocket-market-streams-aggregate-order-book',
    'https://mexcdevelop.github.io/apidocs/spot_v3_en/#websocket-market-streams-mini-ticker',
  ],
  wsTopology: MEXC_WS_TOPOLOGY,
  wsChannels: MEXC_WS_CHANNELS,
  notes: [
    'All market data uses protobuf encoding (binary WebSocket messages).',
    'JSON ping/pong required every 60s to keep connection alive.',
    'Subscription via JSON method: SUBSCRIPTION.',
    'Symbol format: uppercase no separator (BTCUSDT).',
    'REST kline intervals: 1m, 5m, 15m, 30m, 60m (not 1h!), 4h, 8h, 1d, 1W, 1M.',
    'WebSocket kline intervals: Min1, Min5, Min15, Min30, Min60, Hour4, Hour8, Day1, Week1, Month1.',
    'Orderbook updates are incremental, not full snapshots.',
  ],
} as const;
